module.exports = __webpack_public_path__ + "img/pay.ef387e50.png";